import { render, staticRenderFns } from "./left4.vue?vue&type=template&id=9dd1d270&scoped=true&"
import script from "./left4.vue?vue&type=script&lang=js&"
export * from "./left4.vue?vue&type=script&lang=js&"
import style0 from "./left4.vue?vue&type=style&index=0&id=9dd1d270&lang=scss&scoped=true&"
import style1 from "./left4.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd1d270",
  null
  
)

export default component.exports